import React from "react";
import { Link } from 'react-router-dom'
import Icons from "../../../myIcon/Icons";
import { useModal } from "../../../contexts/ModalContext";

export default function PhysicalGrowth({ data }) {
  const {openQueryModal} = useModal();
  return (
    <>
      <section className="physical-growth-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className={`physical-growth-img ${data?.newClass}`}>
                <div className="row">
                  <div className="col-lg-6">
                    <span>{data?.head}</span>
                    <Link className="default-link" onClick={openQueryModal}>{data?.btn} <Icons name={"Longarrow_right"} /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}